import React from "react";
import { BarChart, Bar, Tooltip, XAxis, ResponsiveContainer } from "recharts";
import StackedTooltip from "./StackedTooltip";
import computeTotal from "./computeTotal";
import COLORS from "./Colors";
import useWindowDimensions from "@/hooks/useWindowDimensions";

function Thumbnail({ data: _data, centers, openModal }) {
  const { width } = useWindowDimensions();
  const total = computeTotal(_data);
  const data = [..._data, { ...total, name: "Total" }];

  return (
    <ResponsiveContainer width={width > 640 ? 232 : "100%"} height={232}>
      <BarChart
        data={data}
        margin={{
          top: 56,
          right: 32,
          bottom: 24,
          left: 32,
        }}
        className="bg-tint"
        onClick={width > 640 ? openModal : null}
        cursor="pointer"
      >
        <text
          x={width > 640 ? "17" : "50%"}
          y="28"
          textAnchor={width > 640 ? "start" : "middle"}
          className="font-h3 sm:font-meta-bold"
        >
          Accepted / Declined
        </text>
        <Tooltip content={<StackedTooltip />} />
        <XAxis dataKey="name" hide />
        {centers.map((center, index) => (
          <Bar
            dataKey={center}
            key={center}
            stackId="center"
            fill={COLORS[index]}
            barSize={32}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}

export default Thumbnail;
